module.exports = __webpack_public_path__ + "img/pic-star-tilt.fc1c330.svg";